import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { observable, computed } from 'mobx-angular';
import { ITaskInfo } from '../../interfaces/task-info';
import { HttpClient } from '@angular/common/http';
import {
  DialogStep,
  DialogStepPosition,
} from '../task-supplier-schedule/supplier-schedule-dialog.component';
import { TaskSupplierScheduleSource } from '../task-supplier-schedule/task-supplier-schedule-store';
import { UpdateTaskScheduleDTO } from '../task-supplier-schedule/task-supplier-schedule';

@Component({
  selector: 'view-odometer-image-dialog',
  templateUrl: './view-odometer-image-dialog.component.html',
})
export class ViewOdometerImageDialogComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() imageSource: string;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {}

  close() {
    this.visibleChange.emit(false);
  }
}
